(function () {
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('[data-zava-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    root.querySelectorAll('[data-zava-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('[data-zava-about]').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
